//* External
import AES from 'crypto-js/aes';
import UTF8 from 'crypto-js/enc-utf8';

export const loginKaryaRequests = ({ credentials, tenant }) => {
  const encryptedKey = encryptKaryaUserData(credentials);
  const base = 'https://operacion.ticsocial.com.co/redirect/';
  const url = `${base}?tenant=${tenant}&key=${encryptedKey}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

const encryptKaryaUserData = (data) => {
  const dataEncrypted = AES.encrypt(
    JSON.stringify(data),
    import.meta.env.VITE_ENCRYPTION_KEY_KARYA
  ).toString();
  return dataEncrypted;
};

const decryptKaryaUserData = (data) => {
  let userDataDecrypted = {};
  if (data !== null) {
    const bytes = AES.decrypt(data, import.meta.env.VITE_ENCRYPTION_KEY_KARYA);
    userDataDecrypted = JSON.parse(bytes.toString(UTF8));
  }
  return userDataDecrypted;
};
